import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { RecipesSignIn } from "@/components/views/recipes/recipes-sign-in";
import { RecipesList } from "@/components/views/recipes/recipes-list";
import { ContainerSmall } from "@/components/primitives/container-small";
import { PageContainer } from "@/components/primitives/layout";
import { auth } from "@/lib/auth";

const getRecipesData = createServerFn({ method: "GET" }).handler(async () => {
  const request = getRequest();
  const session = await auth.api.getSession({ headers: request.headers });
  const userId = session?.user?.id;

  if (!userId) {
    return { authenticated: false as const };
  }

  const { getRecipesForUser } = await import("@/lib/api/getUserRecipes.server");
  const recipes = await getRecipesForUser(userId);
  return { authenticated: true as const, recipes, userId };
});

export const Route = createFileRoute("/recipes/")({
  head: () => ({
    meta: [{ title: "Recipes - Scoopulator" }],
  }),
  loader: () => getRecipesData(),
  component: RecipesPage,
});

function RecipesPage() {
  const data = Route.useLoaderData();

  if (!data.authenticated) {
    return (
      <PageContainer>
        <RecipesSignIn />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <ContainerSmall>
        <RecipesList recipes={data.recipes} userId={data.userId} />
      </ContainerSmall>
    </PageContainer>
  );
}
